import * as React from 'react';

const TriangleDownChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2 10L12 14.2 7.8 10z"
        />
    </svg>
);

TriangleDownChunkySvg.displayName = 'TriangleDownChunkySvg';
export default TriangleDownChunkySvg;
